import {
  validatePresence,
  validateLength,
} from 'ember-changeset-validations/validators';

export const ClientStatementAccountDetailValidation = {
  businessName: [validatePresence(true), validateLength({ min: 1, max: 100 })],
};
